import { QueryStatus } from '../../../../../types'
import {OperacionNOTES} from '../types/types'
import { useEffect, useState } from 'react'
import {HttpNOTES} from "../api/httpNOTES";

export const useOperacionNOTES = (idOperacion: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [operacion, setOperacion] = useState<OperacionNOTES>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpNOTES.get(idOperacion)
            .then(data => {
                setOperacion(data)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [idOperacion])

    return { status, operacion }
}
